import React from 'react';
import { Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Information from '../../Information/Information';
import styles from './InvalidLinkContent.module.scss';

export const InvalidLinkContent: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Information
      headerText={t('invalid_link_content.header')}
      bodyText={(
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <div className={styles.errorAlert} role='alert'>
              <span className={styles.errorAlertText}>{t('invalid_link_content.alert')}</span>
            </div>
          </Grid>
          <Grid item xs={12} className={styles.body}>
            {t('invalid_link_content.body')}
          </Grid>
        </Grid>
      )}
      buttonText={t('invalid_link_content.button')}
      handleButtonClick={() => navigate('/edit-profile')}
    />
  );
};
